import { BaseModel } from 'src/app/@shared/base.model';
import { FormMainType } from '@lib/types';
import { OrganizationModel } from 'src/app/organization/@shared/organization.model';
import { Person } from '@common/entities';

export type PersonSource = Person;

export class PersonModel extends BaseModel<PersonSource> {
  public legacyId?: string;
  public type: FormMainType = 'person';
  public firstName: string;
  public lastName: string;
  public displayName: string;
  public academicTitle?: string;
  public emails?: string[];
  public addressCo?: string; // c/o
  public addressStreetAndNumber: string;
  public addressPostalCode: string;
  public addressCity: string;
  public addressFederalState: string;
  public notes?: string;
  public qualifications?: string[];
  public media?: string[];
  public organizations?: OrganizationModel[] = [];
  public phoneNumbers: string[];

  constructor(source: PersonSource) {
    super(source);

    this.legacyId = source.legacyId;
    this.firstName = source.firstName;
    this.lastName = source.lastName;
    this.displayName = [this.lastName, this.firstName]
      .filter(Boolean)
      .join(', ');
    this.academicTitle = source.academicTitle;
    this.emails = source.emails;
    this.phoneNumbers = source.phoneNumbers;
    this.addressCo = source.addressCo;
    this.addressStreetAndNumber = source.addressStreetAndNumber;
    this.addressPostalCode = source.addressPostalCode;
    this.addressCity = source.addressCity;
    this.addressFederalState = source.addressFederalState;
    this.notes = source.notes;
    this.qualifications = source.qualifications;
    this.media = source.media;

    if (source.organizations?.length) {
      this.organizations = source.organizations.map((contactPerson) => {
        return new OrganizationModel(contactPerson.organization);
      });
    }
  }
}
